/*
 * � 2020 Microsoft. All rights reserved.
 */

define ('SolitaireShared/CardLogic/IGameAuthority',[
    'util/TipManager'
], function (TipManager) {

    var IGameAuthority = function () {

    };

    IGameAuthority.MoveState = {
        CanMove: 0,
        CanDealNextDeck: 1,
        NoMovesLeft: 2
    };

    IGameAuthority.prototype.OnTip = function (sender, tipEventArgs) {
        if (TipManager)
            TipManager.tryShowTip(tipEventArgs);
    };


    return IGameAuthority;

});
